export default __webpack_public_path__ + "static/media/Anitasemisquare.ef0608d3.ttf";